import {
  Avatar,
  Box,
  Grid,
  Icon,
  IconButton,
  Skeleton,
  Typography,
  Divider,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../shared/contexts';
import { LayoutShell } from '../../shared/layouts';
import { GlassCard } from '../../shared/components/UI';
import { HomeAppointments } from './pages';
import { authService } from '../../shared/services';

export const Home = () => {
  const navigate = useNavigate();
  const { userProfilePicture, userName, userEmail, userPhone } = useUserContext();

  const {
    data: user,
    refetch,
    isFetching,
  } = useQuery(['user'], () => authService.getUserFromCookie());

  const formatPhone = (phone?: string) => {
    if (!phone || phone.length < 11) {
      return '';
    }

    const phoneNumber = phone.replace(/\D/g, '');
    const areaCode = phoneNumber.substring(0, 2);
    const firstHalf = phoneNumber.substring(3, 7);
    const lastHalf = phoneNumber.substring(7, 11);

    return `(${areaCode}) 9${firstHalf}-${lastHalf}`;
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Bom dia';
    if (hour < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  return (
    <LayoutShell>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 0.5 }}>
          {getGreeting()}, {isFetching ? userName?.split(' ')[0] || <Skeleton width={120} /> : user?.firstName || user?.name?.split(' ')[0] || ''}!
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Aqui está o resumo da sua conta
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xl={3} lg={4} md={5} xs={12} sx={{ display: { xs: 'none', md: 'block' } }}>
          <GlassCard>
            <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Meu Perfil
              </Typography>
              <IconButton onClick={() => navigate('/profile')} size="small">
                <Icon>edit</Icon>
              </IconButton>
            </Box>

            <Box display='flex' justifyContent='center' marginBottom={2}>
              <Avatar src={userProfilePicture} slotProps={{ img: { loading: 'lazy' } }} sx={{ height: 120, width: 120 }} />
            </Box>

            <Box display='flex' flexDirection='column' gap={1.5}>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 0.25 }}>
                  Nome
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {isFetching ? userName?.split(' ')[0] || <Skeleton /> : user?.name}
                </Typography>
              </Box>

              <Divider sx={{ opacity: 0.3 }} />

              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 0.25 }}>
                  E-mail
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {isFetching ? userEmail || <Skeleton /> : (user?.email || 'Não informado')}
                </Typography>
              </Box>

              <Divider sx={{ opacity: 0.3 }} />

              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 0.25 }}>
                  Telefone
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {isFetching ? (userPhone ? formatPhone(userPhone) : <Skeleton />) : formatPhone(user?.phone) || 'Não informado'}
                </Typography>
              </Box>
            </Box>
          </GlassCard>
        </Grid>

        <Grid item xl={9} lg={8} md={7} xs={12}>
          <HomeAppointments
            appointments={user?.appointments}
            refetch={refetch}
          />
        </Grid>
      </Grid>


    </LayoutShell>
  );
};
